<template>
  <div>
    <b-row>
      <b-col
        v-for="(link, index) in rtspData.slice(0, 4)"
        :key="index"
        lg="6"
        md="6"
        sm="12"
      >
        <b-card
          class="video-card gradient-card"
        >
          <b-link
            v-b-modal="'Live1'"
            @click="$refs.RTSP.streamLive(rtsp[index])"
          >
            <div class="video-wrapper">
              <VideoPlayer
                :source="link.RTSP_URL"
                :index="index"
                class="video-player"
              />
            </div>
          </b-link>
          <div style="font-size: 12px; margin: 0; position: absolute; top: 83%; transform: translateX(-1%); padding: 3px;">
            {{ name[index] }}
          </div>
        </b-card>
      </b-col>
    </b-row>
    <Live
      ref="RTSP"
    />
  </div>
</template>

<script>
// import { Hls } from '@vime/vue'
// import Hls from 'hls.js'
import {
  BRow, BCol, BCard, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import Live from './LiveRTSP.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,

    Live,
    VideoPlayer,
  },
  data() {
    return {
      rtsp: [],
      name: [],
      ipaddress: [],
      rtspData: [],
      // ISOnline: [],
      cctvError: '',
      poster: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getRTSPCCTV()
    // await this.for()
    this.interval = setInterval(async () => {
      await this.getRTSPCCTV()
    }, 600000)
  },
  methods: {
    getRTSPCCTV() {
      axios
        .post('/camCrossWalk', { wid: this.$route.query.wid, username: this.userData.username })
        .then(response => {
          this.rtspData.splice(0)
          this.rtsp.splice(0)
          this.name.splice(0)
          this.rtspData = response.data
          this.rtspData.forEach(value => {
            this.rtsp.push(value.RTSP_URL)
            this.name.push(value.Camera_Desc)
            this.ipaddress.push(value.ipaddress)
            // this.ISOnline.push(value.ISOnline)
          })
          // this.for()
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.video-card {
  height: 95%;
  overflow: hidden;
  padding: 0;  /* ลบ padding ของ card */
}

.video-wrapper {
  height: 172px;
  overflow: hidden;
  position: relative;
}

.video-player {
  position: absolute;
  top: 70%;
  left: 0;
  width: 100%;
  height: auto;
  transform: translateY(-50%);
}

.gradient-card {
  background:
    linear-gradient(to right, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to left, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to bottom, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to top, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
  background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: no-repeat;
  border: 1px solid rgb(30, 83, 100, 0.7);
}
</style>
